"use client";
import classNames from "classnames";
import type { JSX } from "react";
import { Facet } from "./Facet";
import { HierarchicalMenu } from "./HierarchicalMenu";
import { FACETS } from "../constants";

export type FacetListProps = {
  initialExpanded?: boolean;
};

export function FacetList({
  className,
  initialExpanded = true,
  ...rest
}: FacetListProps & JSX.IntrinsicElements["div"]) {
  return (
    <div
      id="facet-list"
      className={classNames("auto-rows-min gap-4", className)}
      {...rest}
    >
      <Facet
        config={FACETS["itemDetails.binding"]}
        initialExpanded={initialExpanded}
      />
      <HierarchicalMenu
        config={FACETS["aldersgrupper"]}
        initialExpanded={initialExpanded}
        sort={({ value: a }, { value: b }) => {
          return Number(a.split("-")[0]?.replace(/\D/g, "")) -
            Number(b.split("-")[0]?.replace(/\D/g, "")) >
            0
            ? 1
            : -1;
        }}
      />
      <Facet
        config={FACETS["itemDetails.language"]}
        initialExpanded={initialExpanded}
      />
      <HierarchicalMenu
        config={FACETS["utdanningsniv"]}
        initialExpanded={initialExpanded}
      />
      <HierarchicalMenu
        config={FACETS["lreplan"]}
        initialExpanded={initialExpanded}
      />
      <Facet
        config={FACETS["itemDetails.seriesName"]}
        searchable
        initialExpanded={initialExpanded}
      />
      <Facet
        config={FACETS["itemDetails.literaryWorkName"]}
        searchable
        initialExpanded={initialExpanded}
      />
      <Facet
        searchable
        config={FACETS["authors"]}
        initialExpanded={initialExpanded}
      />
      <HierarchicalMenu
        config={FACETS["kategorier"]}
        initialExpanded={initialExpanded}
      />
    </div>
  );
}
